import { render, staticRenderFns } from "./PerformanceMarketingStartBox.vue?vue&type=template&id=57d31b94&"
import script from "./PerformanceMarketingStartBox.vue?vue&type=script&lang=js&"
export * from "./PerformanceMarketingStartBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports